module.exports = __webpack_public_path__ + "static/img/sky.88a77560.png";